import React, { useEffect, useState } from "react"
import {
  Col,
  Row,
  Label,
  Input,
  UncontrolledTooltip,
  Table,
  Button,
} from "reactstrap"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
import { toast } from "react-toastify"
import PropTypes from "prop-types"
import { useSelector, useDispatch } from "react-redux"
import { withRouter, useParams } from "react-router-dom"
import { connect } from "react-redux"
import { isEmpty } from "lodash"

import notificationAction from "../../../store/bm90aWZp/actions"
import { propTypes } from "react-bootstrap/esm/Image"

const Notification = (props) => {
  const { dispatch, profileData, clientProfile } = props

  useEffect(() => {
    dispatch(notificationAction.loadNotificationDetails(id))
  }, [])

  const { id } = useParams()

  const specificDispatch = useDispatch()
  const [otherDetailSet, setOtherDetailSet] = useState(false)
  const [updateDetails, setUpdateDetails] = useState(false)

  const [deleteOtherDetails, setDeleteOtherDetails] = useState(false)
  const handleOtherDetailsClose = () => setDeleteOtherDetails(false)

  const notificationStore = useSelector((state) => state)
  const notificationUpdate = useSelector((state) => state.notification)

  console.log(notificationStore, "notificationStore")

  const { notification_details = [] } = notificationUpdate

  console.log(notification_details, "notification_details")
  console.log(id, "LeadId from api call")

  const notificationList =
    !isEmpty(notification_details) && notification_details
  console.log(notificationList, "notificationList")

  const otherDetails =
    !isEmpty(notification_details) && notification_details.otherdetail

  const [notificationData, setNotificationData] = useState({
    primaryNo: "",
    primaryNo_checked: "",
    secondaryNo: "",
    secondaryNo_checked: "",
    whatsappNo: "",
    whatsappNo_checked: "",
    emailId: "",
    emailId_checked: "",
    brideMobileNo: "",
    brideMobileNo_checked: "",
    brideWhatappNo: "",
    brideWhatappNo_checked: "",
    brideEmailId: "",
    brideEmailId_checked: "",
    groomMobileNo: "",
    groomMobileNo_checked: "",
    groomWhatsappNo: "",
    groomWhatsappNo_checked: "",
    groomEmailId: "",
    groomEmailId_checked: "",
  })
  const [otherDetailsData, setOtherDetailsData] = useState({
    name: "",
    eventType: [],
    eventContent: "",
  })

  const handleOtherDetailsChange = (e) => {
    setOtherDetailsData({
      ...otherDetailsData,
      [e.target.name]: e.target.value,
    })
  }

  const addNotifications = () => {
    let submitValue = {
      leadId: id,
      notification: [
        {
          name: otherDetailsData.name,
          type: eventType.label,
          contactDetail: otherDetailsData.eventContent,
        },
      ],
    }
    specificDispatch(notificationAction.createNotificationRecord(submitValue))

    setTimeout(() => {
      specificDispatch(notificationAction.loadNotificationDetails(id))
      setOtherDetailSet(false)
      toast.success("Other Details added successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 2000)
  }

  //Dropdown list value

  const [eventType, setEventType] = useState([])
  // const [eventContent, setEventContent] = useState("")
  const [editNotificationId, setEditNotificationId] = useState("")
  const [deleteNotificationId, setDeleteNotificationId] = useState("")

  console.log(deleteNotificationId, "deleteNotificationId")
  console.log(editNotificationId, "editNotificationId")

  //Edit functionality
  const editOtherDetails = (notification) => {
    console.log(notification, "notification")
    setEventType({ value: "", label: notification.type })
    setOtherDetailsData({
      ...otherDetailsData,
      eventType: [{ value: "", label: notification.type }],
      eventContent: notification.contactDetail,
      name: notification.name,
    })
    setUpdateDetails(true)
    setOtherDetailSet(true)
  }

  console.log(editNotificationId, "editNotificationId")
  //updateApi
  const updateNotification = () => {
    let updateNotificationData = {
      leadId: id,
      leadNotificationId: editNotificationId,
      notification: [
        {
          name: otherDetailsData.name,
          type: eventType.label,
          contactDetail: otherDetailsData.eventContent,
        },
      ],
    }
    console.log("BBBBB......", updateNotificationData)
    specificDispatch(
      notificationAction.updateNotificationRecord(updateNotificationData)
    )
    setTimeout(() => {
      specificDispatch(notificationAction.loadNotificationDetails(id))
      toast.success("Other Details updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setUpdateDetails(false)
      setOtherDetailSet(false)
    }, 2000)
  }

  //deleteApi
  const deleteNotification = () => {
    let deleteNotificationData = {
      leadId: id,
      leadNotificationId: deleteNotificationId,
    }
    specificDispatch(
      notificationAction.deleteNotificationRecord(deleteNotificationData)
    )
    setTimeout(() => {
      specificDispatch(notificationAction.loadNotificationDetails(id))
      toast.success("Other Details Deleted successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 2000)
  }

  const primaryCheck = () => {
    let checkboxData = {
      leadId: id,
      notification: {
        client_info_primary_no_ischecked: true,
      },
    }
    specificDispatch(notificationAction.updateCheckbox(checkboxData))
  }
  const secondaryCheck = () => {
    let checkboxData = {
      leadId: id,
      notification: {
        client_info_secondary_no_ischecked: true,
      },
    }
    specificDispatch(notificationAction.updateCheckbox(checkboxData))
  }
  const whatsappCheck = () => {
    let checkboxData = {
      leadId: id,
      notification: {
        client_info_whatsapp_no_ischecked: true,
      },
    }
    specificDispatch(notificationAction.updateCheckbox(checkboxData))
  }
  const emailCheck = () => {
    let checkboxData = {
      leadId: id,
      notification: {
        client_info_email_no_ischecked: true,
      },
    }
    specificDispatch(notificationAction.updateCheckbox(checkboxData))
  }

  const bmobileCheck = () => {
    let checkboxData = {
      leadId: id,
      notification: {
        bride_primary_no_ischecked: true,
      },
    }
    specificDispatch(notificationAction.updateCheckbox(checkboxData))
  }
  const bwhatsappCheck = () => {
    let checkboxData = {
      leadId: id,
      notification: {
        bride_whatsapp_no_ischecked: true,
      },
    }
    specificDispatch(notificationAction.updateCheckbox(checkboxData))
  }

  const bemailCheck = () => {
    let checkboxData = {
      leadId: id,
      notification: {
        bride_email_ischecked: true,
      },
    }
    specificDispatch(notificationAction.updateCheckbox(checkboxData))
  }

  const gmobileCheck = () => {
    let checkboxData = {
      leadId: id,
      notification: {
        groom_primary_no_ischecked: true,
      },
    }
    specificDispatch(notificationAction.updateCheckbox(checkboxData))
  }

  const gwhatsappCheck = () => {
    let checkboxData = {
      leadId: id,
      notification: {
        groom_whatsapp_no_ischecked: true,
      },
    }
    specificDispatch(notificationAction.updateCheckbox(checkboxData))
  }

  const gemailCheck = () => {
    let checkboxData = {
      leadId: id,
      notification: {
        groom_email_ischecked: true,
      },
    }
    specificDispatch(notificationAction.updateCheckbox(checkboxData))
  }

  const handleChange = (e) => {
    setNotificationData({
      ...notificationData,
      [e.target.name]: e.target.value,
    })
  }

  const otherDetailsOptions = [
    {
      label: "EMAIL",
      value: "email",
    },
    {
      label: "MOBILENO",
      value: "mobileNo",
    },
    {
      label: "WHATSAPPNO",
      value: "whatsappNo",
    },
  ]

  const addMore = () => {
    setEventType([])
    setOtherDetailsData({
      eventContent: "",
      name: "",
    })
    setOtherDetailSet(true)
  }

  useEffect(() => {
    setNotificationData({
      ...notificationData,
      primaryNo:
        !isEmpty(clientProfile) && clientProfile
          ? "+91" + clientProfile.primaryNumber.number
          : "",
      secondaryNo:
        !isEmpty(clientProfile) && clientProfile
          ? "+91" + clientProfile.secondaryNumber.number
          : "",
      whatsappNo:
        !isEmpty(clientProfile) && clientProfile
          ? "+91" + clientProfile.whatsappNumber.number
          : "",
      emailId:
        !isEmpty(clientProfile) && clientProfile ? clientProfile.emailId : "",
      brideMobileNo:
        !isEmpty(notification_details) && notification_details
          ? notification_details.bride_primary_no
          : "",
      brideWhatappNo:
        !isEmpty(profileData) && notification_details
          ? notification_details.bride_whatsapp_no
          : "",
      brideEmailId:
        !isEmpty(profileData) && notification_details
          ? notification_details.bride_email
          : "",
      groomMobileNo:
        !isEmpty(profileData) && notification_details
          ? notification_details.groom_primary_no
          : "",
      groomWhatsappNo:
        !isEmpty(profileData) && notification_details
          ? notification_details.groom_whatsapp_no
          : "",
      groomEmailId:
        !isEmpty(profileData) && notification_details
          ? notification_details.groom_email
          : "",
    })
  }, [clientProfile, notification_details])

  return (
    <React.Fragment>
      <Row>
        <Col
          md="12"
          lg="12"
          xl="12"
          sm="12"
          xs="12"
          className="quote-head-content"
        >
          <Row>
            <Col className="">
              <p className="quote-head ms-1">
                Notification
                <span className="quote-info">
                  <i
                    style={{ color: "grey" }}
                    id="quoteInfo"
                    aria-hidden="true"
                    className="fa fa-info-circle ms-1"
                  ></i>
                  <UncontrolledTooltip placement="right" target="quoteInfo">
                    Notification Description
                  </UncontrolledTooltip>
                </span>
              </p>
            </Col>
          </Row>
        </Col>
        <Col
          md="12"
          lg="12"
          xl="12"
          sm="12"
          xs="12"
          className="notification-subhead"
        >
          <Row>
            <Col md="12" lg="12" xl="12" sm="12" xs="12" className="">
              <p className="notification-head">Client</p>
            </Col>
            <Col lg="4" md="4" sm="12" xs="12">
              <div className="d-flex flex-row ">
                <Input
                  name="primaryNo_checked"
                  type="checkbox"
                  value={notificationData.primaryNo_checked}
                  style={{ verticalAlign: " middle" }}
                  onChange={(e) => {
                    if (e.target.checked) {
                      primaryCheck()
                    }
                    handleChange(e)
                  }}
                  className="notification-text-field"
                />
                &nbsp;&nbsp;
                <Label className="checkbox-inline">Primary No</Label>
              </div>
              <Input
                name="primaryNo"
                type="text"
                placeholder="Enter Primary No"
                value={notificationData.primaryNo}
                disabled
                onChange={(e) => handleChange(e)}
                className="notification-text-field"
              />
            </Col>
            <Col lg="4" md="4" sm="12" xs="12">
              <div className="d-flex flex-row ">
                <Input
                  name="secondaryNo_checked"
                  type="checkbox"
                  // placeholder="Enter Primary No"
                  value={notificationData.primaryNo_checked}
                  // disabled
                  onChange={(e) => {
                    if (e.target.checked) {
                      secondaryCheck()
                    }
                    handleChange(e)
                  }}
                />
                &nbsp;&nbsp;
                <Label className="event-label">Secondary No</Label>
              </div>
              <Input
                type="text"
                name="secondaryNo"
                placeholder="Enter Secondary No"
                value={notificationData.secondaryNo}
                disabled
                onChange={(e) => handleChange(e)}
                className="notification-text-field"
              />
            </Col>
            <Col lg="4" md="4" sm="12" xs="12">
              <div className="d-flex flex-row">
                <Input
                  name="whatsappNo_checked"
                  type="checkbox"
                  // placeholder="Enter Primary No"
                  value={notificationData.whatsappNo_checked}
                  // disabled
                  onChange={(e) => {
                    if (e.target.checked) {
                      whatsappCheck()
                    }
                    handleChange(e)
                  }}
                />
                &nbsp;&nbsp;
                <Label className="event-label">WhatsApp No</Label>
              </div>
              <Input
                type="text"
                name="whatsappNo"
                placeholder="Enter WhatsApp No"
                value={notificationData.whatsappNo}
                disabled
                onChange={(e) => handleChange(e)}
                className="notification-text-field"
              />
            </Col>
            <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
              <div className="d-flex flex-row ">
                <Input
                  name="emailId_checked"
                  type="checkbox"
                  // placeholder="Enter Primary No"
                  value={notificationData.emailId_checked}
                  // disabled
                  onChange={(e) => {
                    if (e.target.checked) {
                      emailCheck()
                    }
                    handleChange(e)
                  }}
                />
                &nbsp;&nbsp;
                <Label className="event-label">Email Id</Label>
              </div>
              <Input
                type="text"
                name="emailId"
                value={notificationData.emailId}
                disabled
                placeholder="Enter Email Id"
                onChange={(e) => handleChange(e)}
                className="notification-text-field"
              />
            </Col>
          </Row>
        </Col>
        <Col
          md="12"
          lg="12"
          xl="12"
          sm="12"
          xs="12"
          className="notification-subhead mt-3"
        >
          <Row>
            <Col md="12" lg="12" xl="12" sm="12" xs="12">
              <p className="notification-head">Bride</p>
            </Col>
            <Col lg="4" md="4" sm="12" xs="12">
              <div className="d-flex flex-row ">
                <Input
                  name="brideMobileNo_checked"
                  type="checkbox"
                  value={notificationData.brideMobileNo_checked}
                  onChange={(e) => {
                    if (e.target.checked) {
                      bmobileCheck()
                    }
                    handleChange(e)
                  }}
                />
                &nbsp;&nbsp;
                <Label className="event-label">Mobile No</Label>
              </div>
              <Input
                name="brideMobileNo"
                placeholder="Enter Mobile No"
                value={notificationData.brideMobileNo}
                onChange={(e) => handleChange(e)}
                className="notification-text-field"
                disabled
              />
            </Col>
            <Col lg="4" md="4" sm="12" xs="12">
              <div className="d-flex flex-row ">
                <Input
                  name="brideWhatappNo_checked"
                  type="checkbox"
                  value={notificationData.brideWhatappNo_checked}
                  onChange={(e) => {
                    if (e.target.checked) {
                      bwhatsappCheck()
                    }
                    handleChange(e)
                  }}
                />
                &nbsp;&nbsp;
                <Label className="event-label">WhatsApp No</Label>
              </div>
              <Input
                type="text"
                name="brideWhatsappNo"
                value={notificationData.brideWhatappNo}
                disabled
                placeholder="Enter WhatsApp No"
                onChange={(e) => handleChange(e)}
                className="notification-text-field"
              />
            </Col>
            <Col lg="4" md="4" sm="12" xs="12">
              <div className="d-flex flex-row ">
                <Input
                  name="brideEmailId_checked"
                  type="checkbox"
                  value={notificationData.brideEmailId_checked}
                  onChange={(e) => {
                    if (e.target.checked) {
                      bemailCheck()
                    }
                    handleChange(e)
                  }}
                />
                &nbsp;&nbsp;
                <Label className="event-label">Email Id</Label>
              </div>
              <Input
                type="text"
                name="brideEmailId"
                value={notificationData.brideEmailId}
                disabled
                placeholder="Enter Email Id"
                onChange={(e) => handleChange(e)}
                className="notification-text-field"
              />
            </Col>
          </Row>
        </Col>
        <Col
          md="12"
          lg="12"
          xl="12"
          sm="12"
          xs="12"
          className="notification-subhead mt-3"
        >
          <Row>
            <Col md="12" lg="12" xl="12" sm="12" xs="12" className="">
              <p className="notification-head">Groom</p>
            </Col>
            <Col lg="4" md="4" sm="12" xs="12">
              <div className="d-flex flex-row ">
                {" "}
                <Input
                  name="groomMobileNo_checked"
                  type="checkbox"
                  value={notificationData.groomMobileNo_checked}
                  onChange={(e) => {
                    if (e.target.checked) {
                      gmobileCheck()
                    }
                    handleChange(e)
                  }}
                />
                &nbsp;&nbsp;
                <Label className="event-label">Mobile No</Label>
              </div>

              <Input
                name="groomMobileNo"
                disabled
                value={notificationData.groomMobileNo}
                placeholder="Enter Mobile No"
                onChange={(e) => handleChange(e)}
                className="notification-text-field"
              />
            </Col>
            <Col lg="4" md="4" sm="12" xs="12">
              <div className="d-flex flex-row ">
                <Input
                  name="groomWhatsappNo_checked"
                  type="checkbox"
                  value={notificationData.groomWhatsappNo_checked}
                  onChange={(e) => {
                    if (e.target.checked) {
                      gwhatsappCheck()
                    }
                    handleChange(e)
                  }}
                />
                &nbsp;&nbsp;
                <Label className="event-label">WhatsApp No</Label>
              </div>
              <Input
                type="text"
                name="groomWhatsappNo"
                value={notificationData.groomWhatsappNo}
                disabled
                placeholder="Enter WhatsApp No"
                onChange={(e) => handleChange(e)}
                className="notification-text-field"
              />
            </Col>
            <Col lg="4" md="4" sm="12" xs="12">
              <div className="d-flex flex-row ">
                <Input
                  name="groomEmailId_checked"
                  type="checkbox"
                  value={notificationData.groomEmailId_checked}
                  onChange={(e) => {
                    if (e.target.checked) {
                      gemailCheck()
                    }
                    handleChange(e)
                  }}
                />
                &nbsp;&nbsp;
                <Label className="event-label">Email Id</Label>
              </div>
              <Input
                type="text"
                name="groomEmailId"
                value={notificationData.groomEmailId}
                disabled
                placeholder="Enter Email Id"
                onChange={(e) => handleChange(e)}
                className="notification-text-field"
              />
            </Col>
          </Row>
        </Col>
        {/*Other Details */}
        <Col md="12" xl="12" lg="12" className="mt-3">
          <Row>
            <Col lg="9" md="9" sm="6" xs="6">
              <p className="special-info">
                Other Detail
                <span className="quote-info">
                  <i
                    style={{ color: "grey" }}
                    id="specialInfo"
                    aria-hidden="true"
                    className="fa fa-info-circle ms-1"
                  ></i>
                  <UncontrolledTooltip placement="right" target="specialInfo">
                    Other Details Description
                  </UncontrolledTooltip>
                </span>
              </p>
            </Col>
            <Col lg="3" md="3" sm="6" xs="6">
              <div
                className={
                  profileData.length < 1
                    ? "disabled-button add-more-details"
                    : "add-more-details"
                }
                onClick={() => {
                  addMore()
                }}
              >
                Add More
              </div>
            </Col>
          </Row>
        </Col>
        {otherDetailSet && (
          <Col md="12" xl="12" lg="12" className="mt-3">
            <Table>
              <tbody>
                <tr>
                  <td style={{ width: "25%" }}>
                    <Input
                      name="name"
                      placeholder="Enter Name"
                      value={otherDetailsData.name}
                      onChange={(e) => handleOtherDetailsChange(e)}
                    />
                  </td>
                  <td style={{ width: "25%" }}>
                    <Select
                      name="type"
                      placeholder="Select Type"
                      value={eventType}
                      options={otherDetailsOptions}
                      onChange={(e) => setEventType(e)}
                    />
                  </td>
                  <td style={{ width: "25%" }}>
                    <Input
                      name="eventContent"
                      placeholder="Enter Details"
                      value={otherDetailsData.eventContent}
                      onChange={(e) => handleOtherDetailsChange(e)}
                    />
                  </td>
                  {updateDetails ? (
                    <td style={{ width: "15%" }}>
                      <div className="d-flex flex-row">
                        <div
                          className="add-button btn btn-warning"
                          onClick={() => {
                            setUpdateDetails(false)
                            setOtherDetailSet(false)
                          }}
                        >
                          cancel
                        </div>
                        <div
                          className="add-button btn btn-info"
                          onClick={() => {
                            updateNotification()
                          }}
                        >
                          update
                        </div>
                      </div>
                    </td>
                  ) : (
                    <td style={{ width: "15%" }} className="w-10">
                      <div className="d-flex flex-row">
                        <div
                          className="add-button btn btn-warning"
                          onClick={() => {
                            setOtherDetailSet(false)
                          }}
                        >
                          cancel
                        </div>
                        <div
                          className="add-button btn btn-success"
                          onClick={() => {
                            addNotifications()
                          }}
                        >
                          Add
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              </tbody>
            </Table>
          </Col>
        )}
        <Col className="mt-3">
          <Table bordered responsive>
            <thead style={{ backgroundColor: "#f9f9f9" }}>
              <tr>
                <th style={{ width: "40%" }}>Name</th>
                <th style={{ width: "40%" }}>Type</th>
                <th style={{ width: "40%" }}>Details</th>
                <th className="icon-section" style={{ textAlign: "center" }}>
                  #
                </th>
                <th className="icon-section">#</th>
              </tr>
            </thead>
            <tbody>
              {!isEmpty(otherDetails) && otherDetails.length > 0 ? (
                otherDetails.map((notification) => {
                  return (
                    <tr key={notification._id}>
                      <td>{notification.name}</td>
                      <td>{notification.type}</td>
                      <td>{notification.contactDetail}</td>
                      <td>
                        <button
                          type="submit"
                          className={
                            profileData.length < 1
                              ? "disabled-button add-button"
                              : "add-button"
                          }
                          onClick={() => {
                            editOtherDetails(notification)
                            setEditNotificationId(notification._id)
                          }}
                        >
                          Edit
                        </button>
                      </td>
                      <td>
                        <i
                          className="fa fa-times remove-icon"
                          onClick={() => {
                            // setInstructionsId(item._id)
                            setDeleteNotificationId(notification._id)
                            setDeleteOtherDetails(true)
                          }}
                        ></i>
                      </td>
                    </tr>
                  )
                })
              ) : (
                <>
                  <tr key={0}>
                    <td className="text-align-center" colSpan={5}>
                      No record found
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </Table>
        </Col>

        {deleteOtherDetails && (
          <Modal show={deleteOtherDetails} onHide={handleOtherDetailsClose}>
            <Modal.Header>Delete Others Details</Modal.Header>
            <Modal.Body>
              Are you sure you want to delete the others details ?
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleOtherDetailsClose}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => {
                  deleteNotification()
                  handleOtherDetailsClose()
                  // removeSpecialInstruction()
                }}
              >
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Row>
    </React.Fragment>
  )
}

Notification.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  profileData: propTypes.array,
  clientProfile: propTypes.array,
  notification_details: PropTypes.array,
  baseProps: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = (state) => ({
  // employee: state.employeeRequest.employee,
  notification_details: state.notification.notification_details,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Notification)
)
